import { FadeIn, ChapterHeading } from './Reveal';
import { useLang } from '../i18n/LangContext';

export const MiniGames = () => {
  const { t } = useLang();
  const MINIGAME_TAGS = t.miniGames.tags;
  return (
  <section data-testid="minigames-section" className="relative bg-iskra-bg pb-24 md:pb-32 overflow-hidden">
    <div className="max-w-5xl mx-auto px-5 md:px-8">
      <FadeIn>
        <div className="relative overflow-hidden rounded-[2.5rem] border border-iskra-magenta/25 bg-gradient-to-br from-iskra-surface to-iskra-bg p-8 md:p-14">
          <div className="absolute -top-24 -right-24 w-[340px] h-[340px] rounded-full bg-iskra-pink/20 blur-[110px]" aria-hidden="true" />
          <div className="relative grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <ChapterHeading
                number="07"
                eyebrow={t.miniGames.eyebrow}
                title={t.miniGames.title}
                copy={t.miniGames.copy}
              />
              <ul data-testid="minigame-tags" className="mt-8 flex flex-wrap gap-2.5">
                {MINIGAME_TAGS.map((tag, i) => (
                  <li
                    key={tag}
                    data-testid={`minigame-tag-${i}`}
                    className="rounded-full border border-iskra-magenta/30 bg-iskra-magenta/10 px-4 py-2 text-xs md:text-sm font-bold text-fuchsia-200 hover:bg-iskra-magenta/20 transition-colors duration-300"
                  >
                    {tag}
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative mx-auto w-[230px] md:w-[260px]">
              <div className="absolute inset-0 bg-iskra-magenta/25 blur-[90px] rounded-full" aria-hidden="true" />
              <div className="relative rounded-[2.4rem] bg-[#0B1424] p-[9px] border border-iskra-magenta/30 shadow-[0_40px_100px_-18px_rgba(217,70,239,0.5)]">
                <div className="overflow-hidden rounded-[1.9rem] bg-black aspect-[1170/2532] phone-zoom-alati">
                  <img src="/assets/screen-iskra.webp" alt="KRUG ISKRA — alati i mini-igre" loading="lazy" className="w-full h-full object-cover object-top transition-transform duration-700" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </FadeIn>
    </div>
  </section>
  );
};
